// 呱呱吃瓜 - 演示数据
// 热瓜 / 围观现场 / 分类 / 指南 / FAQ / 口碑

export interface HotMelon {
  id: number;
  tag: string;
  heat: number; // 热度 1-100
  title: string;
  brief: string;
  image: string;
  time: string;
  commentCount: string;
  status: string; // 新瓜 / 发酵中 / 有后续 / 已反转
}

export const hotMelons: HotMelon[] = [
  {
    id: 1,
    tag: '顶流剧组',
    heat: 98,
    title: '顶流小生被曝片场假戏真做？多方连夜发声明回应',
    brief: '某古装大热剧组主演被拍到私下同游，爆料一小时后双方经纪公司先后发声，评论区现场已经吵到前排，蹲一个完整后续。',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20film%20set%20at%20night%20with%20warm%20gossip%20magazine%20lighting%2C%20two%20celebrity%20silhouettes%20walking%20near%20a%20trailer%20van%2C%20paparazzi%20flash%20in%20background%2C%20teal%20and%20orange%20film%20tone%2C%20editorial%20entertainment%20news%20photography&width=900&height=600&seq=hot-01&orientation=landscape',
    time: '12 分钟前',
    commentCount: '12.8k',
    status: '发酵中',
  },
  {
    id: 2,
    tag: '选秀舞台',
    heat: 95,
    title: '限定团解散演唱会门票开售秒空，粉丝票务大战一触即发',
    brief: '人气男团告别场刚刚官宣，票务平台瞬间崩了。黄牛价格水涨船高，粉丝之间已经开始互撕，围观现场持续更新中。',
    image: 'https://readdy.ai/api/search-image?query=concert%20stage%20with%20sweeping%20spotlights%20and%20crowd%20silhouettes%20raising%20hands%2C%20confetti%20in%20air%2C%20live%20idol%20show%20atmosphere%2C%20warm%20and%20cool%20light%20contrast%2C%20dynamic%20event%20photography&width=900&height=600&seq=hot-02&orientation=landscape',
    time: '34 分钟前',
    commentCount: '9.4k',
    status: '发酵中',
  },
  {
    id: 3,
    tag: '商界瓜田',
    heat: 92,
    title: '某互联网大厂年会抽奖现场名场面，网友直呼"比节目好看"',
    brief: '年会上的整活环节被内部员工拍下流出，各种离谱操作刷屏社交平台，评论区已经总结出"年度社死名场面"榜单。',
    image: 'https://readdy.ai/api/search-image?query=modern%20tech%20company%20annual%20party%20stage%20with%20bright%20led%20screens%20and%20cheering%20employees%2C%20joyful%20office%20event%20atmosphere%2C%20vivid%20stage%20lighting%2C%20candid%20corporate%20celebration%20photography&width=900&height=600&seq=hot-03&orientation=landscape',
    time: '1 小时前',
    commentCount: '6.2k',
    status: '新瓜',
  },
  {
    id: 4,
    tag: '经典老瓜',
    heat: 88,
    title: '十年前那场"世纪婚礼"忽然被考古，当事人旧视频再被翻出',
    brief: '一段陈年采访视频被营销号重新搬运，评论区考古大军火速到场，当年的名场面再次被拿出来逐帧分析。',
    image: 'https://readdy.ai/api/search-image?query=vintage%20archival%20video%20room%20with%20old%20tapes%20and%20nostalgic%20warm%20tones%2C%20retro%20interview%20monitor%20glowing%2C%20melancholy%20throwback%20mood%2C%20archive%20footage%20photography&width=900&height=600&seq=hot-04&orientation=landscape',
    time: '2 小时前',
    commentCount: '4.1k',
    status: '已考古',
  },
  {
    id: 5,
    tag: '综艺现场',
    heat: 85,
    title: '演技综艺导师现场毒舌点评上热搜，选手当场情绪失控',
    brief: '最新一期节目播出后，一段导师犀利点评被单独截取出来疯传，网友分成两派吵得不可开交，节目组紧急回应。',
    image: 'https://readdy.ai/api/search-image?query=television%20variety%20show%20studio%20with%20bright%20panel%20lighting%20and%20camera%20crane%2C%20judges%20at%20desk%20and%20stage%20light%2C%20lively%20tv%20production%20set%2C%20editorial%20behind%20scenes%20photography&width=900&height=600&seq=hot-05&orientation=landscape',
    time: '3 小时前',
    commentCount: '3.8k',
    status: '有后续',
  },
  {
    id: 6,
    tag: '反转现场',
    heat: 90,
    title: '爆料人凌晨晒出完整聊天记录，剧情迎来大反转',
    brief: '此前引发热议的争议事件迎来新进展，完整记录曝光后舆论风向突变，此前站队的前排网友直呼"又被耍了"。',
    image: 'https://readdy.ai/api/search-image?query=mysterious%20phone%20chat%20messages%20glowing%20on%20screen%20in%20dark%20room%2C%20dramatic%20blue%20and%20violet%20backlight%20from%20laptop%2C%20suspenseful%20social%20media%20drama%20concept%20photography&width=900&height=600&seq=hot-06&orientation=landscape',
    time: '5 小时前',
    commentCount: '7.6k',
    status: '已反转',
  },
];

export interface LiveRoom {
  id: number;
  name: string;
  desc: string;
  watching: number;
  replies: number;
  status: string;
  group: string;
  image: string;
}

export const liveRooms: LiveRoom[] = [
  {
    id: 1,
    name: '蹲一个剧组官宣',
    desc: '顶流同剧组是否假戏真做？等官方声明中，实时搬运双方回应与路透。',
    watching: 28412,
    replies: 3215,
    status: '发酵中',
    group: '娱乐圈',
    image: 'https://readdy.ai/api/search-image?query=people%20waiting%20and%20watching%20a%20large%20neon%20screen%20at%20night%20with%20curiosity%2C%20crowd%20front%20row%20silhouettes%2C%20live%20updates%20concept%2C%20cinematic%20urban%20night%20photography&width=800&height=800&seq=live-01&orientation=squarish',
  },
  {
    id: 2,
    name: '限定团解散倒计时',
    desc: '告别演唱会票务风波追踪，票价、黄牛、路透一条龙整理。',
    watching: 19537,
    replies: 2641,
    status: '发酵中',
    group: '选秀',
    image: 'https://readdy.ai/api/search-image?query=counting%20down%20timer%20screen%20over%20concert%20arena%20with%20blue%20confetti%20and%20spotlight%2C%20final%20concert%20farewell%20mood%2C%20dynamic%20live%20show%20photography&width=800&height=800&seq=live-02&orientation=squarish',
  },
  {
    id: 3,
    name: '演技综艺毒舌名场面',
    desc: '导师点评争议持续发酵，各方立场逐条拆解中。',
    watching: 12046,
    replies: 1538,
    status: '有后续',
    group: '综艺',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20spotlight%20on%20empty%20tv%20studio%20stage%20with%20judge%20chairs%2C%20harsh%20criticism%20mood%2C%20bright%20television%20lighting%2C%20competition%20show%20photography&width=800&height=800&seq=live-03&orientation=squarish',
  },
  {
    id: 4,
    name: '微博之夜红毯前哨',
    desc: '造型爆料、座位表流出、同框预判，名场面前瞻直播中。',
    watching: 8831,
    replies: 987,
    status: '新瓜',
    group: '红毯',
    image: 'https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20event%20at%20night%20with%20golden%20bokeh%20lights%20and%20velvet%20barrier%2C%20celebrities%20arriving%20silhouette%2C%20luxury%20awards%20ceremony%20photography&width=800&height=800&seq=live-04&orientation=squarish',
  },
];

export interface Category {
  id: number;
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { id: 1, name: '娱乐圈', desc: '剧集 · 音乐 · 影视', icon: 'ri-star-smile-line', count: 1284 },
  { id: 2, name: '选秀舞台', desc: '男团 · 女团 · 出道', icon: 'ri-mic-line', count: 862 },
  { id: 3, name: '商界瓜田', desc: '大厂 · 创业 · 大佬', icon: 'ri-briefcase-line', count: 431 },
  { id: 4, name: '红毯现场', desc: '造型 · 同框 · 名场面', icon: 'ri-camera-3-line', count: 356 },
  { id: 5, name: '综艺盘点', desc: '名场面 · 番位', icon: 'ri-clapperboard-line', count: 617 },
  { id: 6, name: '考古专区', desc: '旧瓜 · 老粉回忆', icon: 'ri-time-line', count: 298 },
];

export interface GuideStep {
  no: string;
  title: string;
  desc: string;
  icon: string;
}

export const guideSteps: GuideStep[] = [
  { no: '01', title: '锁定热瓜源头', desc: '先看爆料号首发时间线，再比对多方信源，避免只听单方面说法。', icon: 'ri-radar-line' },
  { no: '02', title: '蹲进前排围观', desc: '进入现场房间，弹幕与评论区同步滚屏，实时捕捉最新回应与路透。', icon: 'ri-eye-line' },
  { no: '03', title: '别急着下结论', desc: '新瓜往往有反转，等官方声明与完整记录，理性吃瓜不当急先锋。', icon: 'ri-mental-health-line' },
  { no: '04', title: '礼貌文明发言', desc: '围观不造谣、不攻击当事人，前排蹲瓜也要守住基本素养。', icon: 'ri-chat-smile-3-line' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: '呱呱吃瓜是怎么做到"实时直播"的？',
    a: '我们把散落在各平台的一手动态、弹幕热评和各方回应实时聚合进"围观现场"房间，事件一有新进展就会滚动更新，让你前排蹲瓜不落单，一条龙掌握整条时间线。',
  },
  {
    q: '围观现场里的"弹幕"和"评论"有什么区别？',
    a: '弹幕是随事件滚动、按时间顺序快速刷新的即时反应；评论区则按热度排序，用于沉淀带逻辑的观点、反驳与追问。两者都在现场房间内同步更新，方便你一边看新瓜一边等讨论。',
  },
  {
    q: '事件状态"发酵中 / 有后续 / 已反转"是怎么判断的？',
    a: '由小编结合官方声明、多方信源和事态走向人工标注：尚未定论为"发酵中"，当事方已二次回应为"有后续"，主要指控被推翻或有完整记录佐证反转即为"已反转"。',
  },
  {
    q: '吃瓜应该注意哪些红线？',
    a: '不造谣、不传谣、不人肉、不辱骂当事人。围观现场仅搬运已公开信息，涉及隐私与违法内容会即时屏蔽。理性吃瓜，把"看热闹"控制在尊重事实与尊重他人的范围内。',
  },
  {
    q: '看到最新动态，我该去哪里爆料或投稿？',
    a: '页面底部的"爆料投稿"表单随时开放，提交后小编会核实信源。采纳线索时会做脱敏处理，并优先核实真实性，确保不传播未经证实的私人信息。',
  },
  {
    q: '每天什么时候更新频率最高？',
    a: '通常热点事件集中在晚间和周末爆发，我们 24 小时值守关键现场，白天也会持续滚动整理已有事件的后续，热门事件的响应一般在数分钟内。',
  },
];

export interface Praise {
  name: string;
  role: string;
  text: string;
  avatar: string;
  tag: string;
}

export const praises: Praise[] = [
  {
    name: '前排吃瓜第一名',
    role: '活跃用户 · 追星三年',
    text: '蹲了好几天这个剧组瓜，呱呱现场更新是真快，官方一发声明几分钟就有整理版，比我自己刷微博省心多了。',
    avatar: 'https://readdy.ai/api/search-image?query=cheerful%20young%20asian%20woman%20avatar%20portrait%20smiling%20with%20soft%20studio%20lighting%2C%20friendly%20community%20user%20profile%20photo&width=200&height=200&seq=avatar-01&orientation=squarish',
    tag: '围观老手',
  },
  {
    name: '沙发管理员',
    role: '社区守护者',
    text: '最难得的是这里不乱带节奏，评论区吵归吵，但小编会把各方回应摆清楚，让看客自己判断，这点很加分。',
    avatar: 'https://readdy.ai/api/search-image?query=confident%20young%20man%20avatar%20portrait%20wearing%20glasses%20with%20friendly%20smile%2C%20warm%20neutral%20studio%20background%2C%20community%20moderator%20profile%20photo&width=200&height=200&seq=avatar-02&orientation=squarish',
    tag: '理性吃瓜派',
  },
  {
    name: '考古队长',
    role: '老粉 · 混迹内娱',
    text: '那些多年前的老瓜被翻出来我都找不回原帖，呱呱的考古专区能整理出完整时间线，连当年的旧视频都能顺着翻到，太顶了。',
    avatar: 'https://readdy.ai/api/search-image?query=stylish%20young%20woman%20avatar%20portrait%20with%20curly%20hair%20smiling%20naturally%2C%20soft%20daylight%20background%2C%20authentic%20community%20profile%20photo&width=200&height=200&seq=avatar-03&orientation=squarish',
    tag: '考古爱好者',
  },
];

export interface StatItem {
  value: string;
  label: string;
}

export const stats: StatItem[] = [
  { value: '386k+', label: '围观网友在线' },
  { value: '9 千+', label: '已跟进吃瓜事件' },
  { value: '实时', label: '动态滚屏更新' },
  { value: '24h', label: '关键时刻值守' },
];